
// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

import { EnumStatusBadge } from "components/badges/status-badges/enum-status-badge/enum-status-badge";
import { Card } from "components/card/card";
import { Paragraph } from "components/typography/paragraph/paragraph";
import { EvaluationStatus, EvaluationStatusDisplayNames, EvaluationStatusMap } from "models/enumerations/enrollments/evaluation-status";
import { EnrollmentRecord } from "models/view-models/enrollments/enrollment-record";
import { JSX, useMemo, useState } from "react";
import { t } from "utilities/localization/t";
import { ContextMenu } from "components/context-menu/context-menu/context-menu";
import { ContextMenuButton } from "components/context-menu/context-menu-button/context-menu-button";
import { EvaluationExemptionModal } from "components/user-management/evaluation-exemption-modal/evaluation-exemption-modal";
import "./evaluation-exemption-page.scss";

interface UserEvaluationExemptionProps {
    enrollment: EnrollmentRecord;
    onEnrollmentEvaluationExemptionSave: (enrollment: EnrollmentRecord) => Promise<boolean>;
}

const CSS_CLASS_NAME = "evaluation-exemption-page";

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const UserEvaluationExemption: React.FC<UserEvaluationExemptionProps> = ({
    enrollment,
    onEnrollmentEvaluationExemptionSave
}): JSX.Element => {
    
    const [showEvaluationExemptionModal, setShowEvaluationExemptionModal] = useState(false);

    const onGrantEvaluationExemptionClick = () => {
        setShowEvaluationExemptionModal(true);
    };

    const getEnrollmentEvaluationStatus = useMemo(
        () => {
            if (enrollment.evaluationExemptionGranted) {
                return EvaluationStatus.Exempt;
            } else if (enrollment.isComplete()) {
                return EvaluationStatus.Complete;
            }
            else return EvaluationStatus.NotStarted;
        },
        [enrollment.evaluationExemptionGranted, enrollment.isComplete()]
    );
    
    return (
        <div className={`${CSS_CLASS_NAME}`}>
            <div className={`${CSS_CLASS_NAME}__heading`}>
                <h3>{t("evaluation")}</h3>
            </div>
            <div key={`unitid`} className={`${CSS_CLASS_NAME}__section ${CSS_CLASS_NAME}__evaluation`}>
                <Card key='test' cssClassName="evaluation">
                    <div className="evaluation__name">
                        <Paragraph>
                            {t("evaluation")}
                        </Paragraph>
                    </div>
                    <div className="evaluation__details">
                        <div>
                        </div>
                        <div>
                        </div>
                        <div>
                            <EnumStatusBadge
                                displayNames={
                                    EvaluationStatusDisplayNames
                                }
                                statusMap={EvaluationStatusMap}
                                value={getEnrollmentEvaluationStatus}
                            />
                        </div>
                        <div className="evaluation__score">
                            &nbsp;
                        </div>
                        <div>
                              <ContextMenu>
                                <ContextMenuButton
                                    displayName={t("grantEvaluationExemption")}
                                    onClick={onGrantEvaluationExemptionClick}
                                />
                            </ContextMenu>
                        </div>
                    </div>
                </Card>
            </div>
            <EvaluationExemptionModal
                disabled={enrollment.isComplete()}
                enrollmentToEdit={enrollment}
                open={showEvaluationExemptionModal}
                setOpen={setShowEvaluationExemptionModal}
                onSave={onEnrollmentEvaluationExemptionSave}
            />
        </div>
    );
};
    
    // #endregion Component
    
    // -------------------------------------------------------------------------------------------------
    // #region Exports
    // -------------------------------------------------------------------------------------------------
    
    export { UserEvaluationExemption };